import { useContext } from 'react';
import { EffectContext, EffectContextValue } from '@/context/EffectContext';

export const useEffectContext = (): EffectContextValue => {
    const value = useContext(EffectContext());
    if (!value) {
        throw new Error('useEffectContext must be used within a EffectContextProvider');
    }

    return value;
};
